import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';
import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import type { FetchPolicy } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';

import type {
	experimentalGetAutomationRuleByIdQuery as experimentalGetAutomationRuleByIdQueryData,
	experimentalGetAutomationRuleByIdQueryVariables,
} from '../__types__/GetAutomationRuleByIdQuery.ts';

export const useExperimentalGetAutomationRuleByIdQuery = ({
	skip,
	onError,
	variables,
	fetchPolicy,
}: {
	skip?: boolean;
	onError?: (error: ApolloErrorInterop) => void;
	variables: experimentalGetAutomationRuleByIdQueryVariables;
	fetchPolicy?: FetchPolicy;
}) => {
	return useExperimentalQuery<
		experimentalGetAutomationRuleByIdQueryData,
		experimentalGetAutomationRuleByIdQueryVariables,
		AutomationRuleByIdResponse
	>({
		url: `/gateway/api/automation/internal-api/confluence/${variables.cloudId}/${variables.automationStack}/rest/${variables.spaceId}/rule/${variables.ruleId}`,
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		credentials: 'include',
		parseResult: (response: AutomationRuleByIdResponse) => ({
			experimentalGetAutomationRuleById: {
				id: response.id,
				idUuid: response.idUuid,
				clientKey: response.clientKey,
				name: response.name,
				state: response.state,
				description: response.description,
				authorAccountId: response.authorAccountId,
				actor: response.actor,
				created: response.created,
				updated: response.updated,
				trigger: response.trigger,
				components: response.components,
				canOtherRuleTrigger: response.canOtherRuleTrigger,
				notifyOnError: response.notifyOnError,
				projects: response.projects,
				labels: response.labels,
				tags: response.tags,
				ruleScope: response.ruleScope,
				ruleHome: response.ruleHome,
				writeAccessType: response.writeAccessType,
				collaborators: response.collaborators,
				billingType: response.billingType,
			},
		}),
		skip,
		onError,
		variables,
		fetchPolicy,
	});
};

type AutomationRuleByIdResponse = {
	id: string | null;
	idUuid: string | null;
	clientKey: string | null;
	name: string | null;
	state: any | null;
	description: string | null;
	authorAccountId: string | null;
	actor: any | null;
	created: any | null;
	updated: any | null;
	trigger: any | null;
	components: any | null;
	canOtherRuleTrigger: boolean | null;
	notifyOnError: string | null;
	projects: any | null;
	labels: any | null;
	tags: any | null;
	ruleScope: any | null;
	ruleHome: any | null;
	writeAccessType: any | null;
	collaborators: any | null;
	billingType: any | null;
};
